const VOLUME_STORAGE_KEY = "sanofi.podcastPlayer.volume";
const DEFAULT_VOLUME = 1;

const isStoredVolume = value => typeof value === "number" && Number.isFinite(value) && value >= 0 && value <= 1;

const getLocalStorage = () => {
    try {
        return window.localStorage;
    } catch (e) {
        return undefined;
    }
};

export const readStoredVolume = () => {
    try {
        const storage = getLocalStorage();
        const raw = storage ? storage.getItem(VOLUME_STORAGE_KEY) : null;
        if (raw === null || raw === undefined) return DEFAULT_VOLUME;
        const parsed = JSON.parse(raw);
        return isStoredVolume(parsed) ? parsed : DEFAULT_VOLUME;
    } catch (e) {
        return DEFAULT_VOLUME;
    }
};

export const writeStoredVolume = volume => {
    if (!isStoredVolume(volume)) return;
    try {
        const storage = getLocalStorage();
        if (storage) storage.setItem(VOLUME_STORAGE_KEY, JSON.stringify(volume));
    } catch (e) {
        // Disabled storage or quota: playback continues without persistence.
    }
};
